import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { cloneElement } from 'react';
const SideNavigationLink = ({ icon, render, title, to, variant, ...rest }) => {
    const currentUrl = window.location.pathname;
    const dataAttributes = useDataAttributes(rest);
    const isSelected = currentUrl.startsWith(to);
    return render(buildClassName('flex items-center px-4 py-2 skyline-text-body-2 leading-5 no-underline h-12 tablet:justify-center tablet:items-center mobile:justify-center mobile:items-center', {
        'text-primary-dark bg-white visited:text-primary-dark': isSelected,
        'text-darker-gray bg-white visited:text-darker-gray': variant === 'secondary',
        'text-white hover:bg-[#2C72AA] visited:text-white': !isSelected && variant === 'primary',
    }), to, _jsxs(_Fragment, { children: [_jsx("div", { ...dataAttributes, children: cloneElement(icon, {
                    className: 'mr-2 align-middle tablet:mr-0',
                    'aria-label': title,
                }) }), _jsx("div", { className: "tablet:hidden whitespace-nowrap", children: title })] }));
};
export default SideNavigationLink;
//# sourceMappingURL=SideNavigationLink.js.map